import React from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import EhcParticipantsMiniTable from './ParticipantsMiniTable';

// MUI transitions
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';

export default class EhcParticipantsCompletion extends React.Component {
  constructor(props) {
    super(props);
  }

  baseUrl = (company_id) => {
    if (Array.isArray(company_id)) { // If company_id is an array, do not use company path
      company_id = null;
    }

    return `/api/ehc/${company_id ? `companies/${company_id}/` : ''}participants`;
  };

  handleParticipantsCompletion = async (event) => {
    event.preventDefault();

    const participants = this.props.participants;
    if (!this.props.editable || !participants || participants.length < 1) return;

    const participantIds = participants.map(participant => participant.id);
    const companyIds = [...new Set(participants.map(participant => participant.company_id))];
    const csrfToken = document.querySelector('[name=csrf-token]').content;

    let url = '';
    let req = {};
    if (participantIds.length > 1) { // Batch complete API for multiple participants
      url = this.baseUrl(companyIds) + '/batch_complete';
      req = {
        method: 'POST',
        body: JSON.stringify({ participant_ids: participantIds }),
        headers: {
          "Content-type": "application/json; charset: UTF-8",
          'X-CSRF-Token': csrfToken
        }
      };
    }
    else {
      url = this.baseUrl(companyIds[0]) + '/' + participantIds[0] + '/complete';
      req = {
        method: 'POST',
        headers: {
          "Content-type": "application/json; charset: UTF-8",
          'X-CSRF-Token': csrfToken
        }
      };
    }

    try {
      const response = await fetch(url, req);
      if (response.status >= 400) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      console.log(`${participantIds.length > 1 ? 'Batch complete' : 'Complete'} result:`, result);

      this.props.onClose();
      if (this.props.tableRef.current) {
        this.props.tableRef.current.onQueryChange();
      }
    } catch (err) {
      console.error(`${participantIds.length > 1 ? 'Batch complete' : 'Complete'} error:`, err);
      return;
    }
  };

  // =====================
  // Render Component
  // =====================
  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={this.props.onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={this.props.open} timeout={500}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            bgcolor="#fff"
            p={4}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              outline: 'none',
              borderRadius: '4px',
              minWidth: '300px'
            }}
          >
            <form onSubmit={this.handleParticipantsCompletion}>
              <Typography variant="h6" gutterBottom>
                Are you sure you want to complete selected participant(s)?
              </Typography>

              {this.props.participants && this.props.participants.length > 0 &&
                <EhcParticipantsMiniTable participants={this.props.participants} />
              }

              <Box className="d-flex justify-content-end">
                <Button
                  variant="outlined"
                  onClick={this.props.onClose}
                  className="mr-2"
                >
                  Cancel
                </Button>
                {this.props.editable &&
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!this.props.participants || this.props.participants.length < 1}
                    className="mr-2"
                    type="submit"
                  >
                    Complete
                  </Button>
                }
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    );
  }
}
